import script from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseItem.vue?vue&type=script&setup=true&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=20c16584&scoped=true&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c16584"]])

export default __exports__